import LocaleStrings from "Languages";
import {
  DASHBOARD_BADGE_ALL_USER_LIST,
  DASHBOARD_BADGE_USER_LIST,
  IS_BADGE_DESIGN_MODAL_OPEN,
  DASHBOARD_BADGE_DESIGN_ALL_LIST,
  DASHBOARD_BADGE_DESIGN_LIST,
  IS_GENERATE_BADGE_MODAL_OPEN,
  SELECTED_ELEMENT,
  DASHBOARD_BADGE_JSON,
  DASHBOARD_BADGE_EDITDATA,
  LOGIN_USER_DETAILS,
  IS_PRINT_PREVIEW_MODAL_OPEN,
  IMAGE_ELEMENT_MODAL,
} from "BadgeDesignAction";
import {
  DEFAULTFONTSIZE,
  DEFAULTFONTFAMILY,
} from "../components/badge-constants";

/* 
  Store: Badge Design display Modal 
*/
export const isBadgeDesignModalOpen = (state = false, action) => {
  switch (action.type) {
    case IS_BADGE_DESIGN_MODAL_OPEN:
      return action.payload;
    default:
      return state;
  }
};

/* 
  Store: Generate Badge Modal 
*/
export const isGenerateBadgeModalOpen = (state = false, action) => {
  switch (action.type) {
    case IS_GENERATE_BADGE_MODAL_OPEN:
      return action.payload;
    default:
      return state;
  }
};

/* Store: Print preview Moal */
export const isPrintPreviewModalOpen = (state = false, action) => {
  switch (action.type) {
    case IS_PRINT_PREVIEW_MODAL_OPEN:
      return action.payload;
    default:
      return state;
  }
};

/* Store : badge all user list */
export var DashboardBadgeAllUserList = (state = {}, action) => {
  if (action.type === DASHBOARD_BADGE_ALL_USER_LIST) {
    return action.payload;
  }
  return state;
};

/* Store : badge user list */
export var DashboardBadgeUserList = (state = {}, action) => {
  if (action.type === DASHBOARD_BADGE_USER_LIST) {
    return action.payload;
  }
  return state;
};

/*
  Store: Dashboard Badge design list [Action name-fetchBadgeList]
*/
export var dashboardAllBadgeList = (state = {}, action) => {
  if (action.type === DASHBOARD_BADGE_DESIGN_ALL_LIST) {
    return action.payload;
  }
  return state;
};

/*
  Store: Dashboard Badge design list [Action name-fetchBadgeList]
*/
export var dashboardBadgeList = (state = {}, action) => {
  if (action.type === DASHBOARD_BADGE_DESIGN_LIST) {
    return action.payload;
  }
  return state;
};

export var badgeDefaultStructure = [
  {
    id: "event_name",
    name: "#event_name",
    checkboxLabel: LocaleStrings.badge_element_event_name,
    hidden: false,
    handle: ".handle-event_name move",
    scale: 1,
    x: 205,
    y: 25,
    iscustom: false,
    style: {
      border: "1px solid #DBDFE7",
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 0,
  },
  {
    id: "event_location",
    name: "#event_location",
    checkboxLabel: LocaleStrings.badge_element_event_location,
    hidden: true,
    handle: ".handle-event_location move",
    scale: 1,
    x: 206,
    y: 141,
    iscustom: false,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 1,
  },
  {
    id: "event_logo",
    name: "#event_logo",
    checkboxLabel: LocaleStrings.badge_element_event_logo,
    hidden: true,
    handle: ".handle-event_logo move",
    scale: 1,
    x: 49,
    y: 25,
    iscustom: false,
    style: {
      width: 100,
      height: 100,
      position: "absolute",
    },
    htmlType: "image",
    displayOrder: 2,
  },
  {
    id: "full_name",
    name: "#full_name",
    checkboxLabel: LocaleStrings.badge_element_full_name,
    hidden: false,
    handle: ".handle-full_name move",
    scale: 1,
    x: 205,
    y: 81,
    iscustom: false,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 3,
  },
  {
    id: "first_name",
    name: "#first_name",
    checkboxLabel: LocaleStrings.badge_element_first_name,
    hidden: true,
    handle: ".handle-first_name move",
    scale: 1,
    x: 510,
    y: 77,
    iscustom: false,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 4,
  },
  {
    id: "last_name",
    name: "#last_name",
    checkboxLabel: LocaleStrings.badge_element_last_name,
    hidden: true,
    handle: ".handle-last_name move",
    scale: 1,
    x: 352,
    y: 77,
    iscustom: false,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 5,
  },
  {
    id: "company_name",
    name: "#company_name",
    checkboxLabel: LocaleStrings.badge_element_company_name,
    hidden: true,
    handle: ".handle-company_name",
    scale: 1,
    x: 47,
    y: 290,
    iscustom: false,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 6,
  },
  {
    id: "designation",
    name: "#designation",
    checkboxLabel: LocaleStrings.badge_element_designation,
    hidden: true,
    handle: ".handle-designation move",
    scale: 1,
    x: 237,
    y: 281,
    iscustom: false,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 7,
  },
  {
    id: "qr_code",
    name: "#qr_code",
    checkboxLabel: LocaleStrings.badge_element_qr_code,
    hidden: false,
    handle: ".handle-qr_code move",
    scale: 1,
    x: 502,
    y: 234,
    iscustom: false,
    style: {
      height: 100,
      width: 100,
      position: "absolute",
    },
    htmlType: "zoominout",
    displayOrder: 8,
  },
  {
    id: "registration_type",
    name: "#registration_type",
    checkboxLabel: LocaleStrings.badge_element_registration_type,
    hidden: true,
    handle: ".handle-registration_type move",
    scale: 1,
    x: 507,
    y: 175,
    iscustom: false,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 9,
  },
  {
    id: "primary_group",
    name: "#primary_group",
    checkboxLabel: LocaleStrings.badge_element_primary_group,
    hidden: true,
    handle: ".handle-primary_group move",
    scale: 1,
    x: 407,
    y: 175,
    iscustom: false,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "div",
    displayOrder: 10,
  },
  {
    id: "input_1",
    name: "#input_1",
    checkboxLabel: LocaleStrings.badge_element_input_type,
    hidden: true,
    handle: ".handle-input_1 move",
    scale: 1,
    x: 130,
    y: 183,
    textValue: "",
    iscustom: true,
    label: true,
    levelVal: 1,
    style: {
      width: "max-content",
      height: "max-content",
      textAlign: "center",
      textDecoration: "",
      fontWeight: "normal",
      fontSize: DEFAULTFONTSIZE,
      fontFamily: DEFAULTFONTFAMILY,
      fontStyle: "",
      position: "absolute",
    },
    htmlType: "input",
    displayOrder: 11,
  },
];

/*
Store the data for badge json (Array of objects)
*/
export var templateJson = (state = [], action) => {
  if (action.type === DASHBOARD_BADGE_JSON) {
    if (typeof action.payload === "undefined") {
      return JSON.parse(JSON.stringify(badgeDefaultStructure));
    } else if (state.length > 0) {
      return action.payload;
    } else {
      return JSON.parse(JSON.stringify(badgeDefaultStructure));
    }
  }

  return state;
};

/*
  STORE THE DATA FOR BADGE IN EDIT MODE
*/
export var dataInEditMode = (state = [], action) => {
  if (action.type === DASHBOARD_BADGE_EDITDATA) {
    return action.payload;
  }
  return state;
};

export var selectedElement = (state = {}, action) => {
  if (action.type === SELECTED_ELEMENT) {
    return action.payload;
  }
  return state;
};

/* Login user details [like - Designarion ,Company] */
export var userDetails = (state = [], action) => {
  if (action.type === LOGIN_USER_DETAILS) {
    return action.payload;
  }
  return state;
};

export var imageElementModal = (state = {}, action) => {
  if (action.type === IMAGE_ELEMENT_MODAL) {
    return action.payload;
  }
  return state;
};
